var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKycFailed = function SvgKycFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ED220D",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 5.245.354 4.8c.01.12.109.212.228.212h.285c.12 0 .219-.092.228-.212l.355-4.8A.229.229 0 0 0 8.222 5H7.23A.229.229 0 0 0 7 5.245Zm.44 5.584h.571c.126 0 .229.102.229.228v.572a.229.229 0 0 1-.229.228H7.44a.229.229 0 0 1-.229-.228v-.572c0-.126.102-.228.229-.228Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
export default SvgKycFailed;